module.exports = __webpack_public_path__ + "static/media/wallet5.47154103.jpg";